import ApiService from 'api-client/ApiService'

// TODO: class is named `Heat` (copy-paste artifact from Heat.ts) but getClassName() returns 'mors'
class Heat extends ApiService {
  public getClassName() {
    return 'mors'
  }

  protected async getEndpoint() {
    const endpoint = await this.client.keystone.getServiceEndpoint('mors', 'public')
    return `${endpoint}/v1`
  }

  getLeasePolicies = async () => {
    const response = await this.client.basicGet<any>({
      url: `/tenant/`,
      options: {
        clsName: this.getClassName(),
        mthdName: 'getLeasePolicies',
      },
    })
    return response?.all_tenants ? response.all_tenants.map((policy) => policy.vm_lease_policy) : []
  }

  getLeasePolicy = async ({ tenantId }) => {
    const currentTenant = this.client.activeProjectId
    const tenant = tenantId || currentTenant
    const response = await this.client.basicGet<any>({
      url: `/tenant/${tenant}`,
      options: {
        clsName: this.getClassName(),
        mthdName: 'getLeasePolicy',
      },
    })
    return response?.vm_lease_policy
  }

  createLeasePolicy = async ({ tenantId, body }) => {
    const currentTenant = this.client.activeProjectId
    const tenant = tenantId || currentTenant
    const response = await this.client.basicPost<any>({
      url: `/tenant/${tenant}`,
      body,
      options: {
        clsName: this.getClassName(),
        mthdName: 'createLeasePolicy',
      },
    })
    return response
  }

  updateLeasePolicy = async ({ tenantId, body }) => {
    const currentTenant = this.client.activeProjectId
    const tenant = tenantId || currentTenant
    const response = await this.client.basicPut<any>({
      url: `/tenant/${tenant}`,
      body,
      options: {
        clsName: this.getClassName(),
        mthdName: 'updateLeasePolicy',
      },
    })
    return response
  }

  deleteLeasePolicy = async ({ tenantId }) => {
    const currentTenant = this.client.activeProjectId
    const tenant = tenantId || currentTenant
    return this.client.basicDelete<any>({
      url: `/tenant/${tenant}`,
      options: {
        clsName: this.getClassName(),
        mthdName: 'deleteLeasePolicy',
      },
    })
  }

  getVmLeases = async ({ tenantId }) => {
    const currentTenant = this.client.activeProjectId
    const tenant = tenantId || currentTenant
    const response = await this.client.basicGet<any>({
      url: `/tenant/${tenant}/instances`,
      options: {
        clsName: this.getClassName(),
        mthdName: 'getLeases',
      },
    })
    return response?.all_vms
  }

  getVmLease = async ({ tenantId, vmId }) => {
    const currentTenant = this.client.activeProjectId
    const tenant = tenantId || currentTenant
    const response = await this.client.basicGet<any>({
      url: `/tenant/${tenant}/instance/${vmId}`,
      options: {
        clsName: this.getClassName(),
        mthdName: 'getLease',
      },
    })
    return response
  }

  createVmLease = async ({ tenantId, vmId, body }) => {
    const currentTenant = this.client.activeProjectId
    const tenant = tenantId || currentTenant
    const response = await this.client.basicPost<any>({
      url: `/tenant/${tenant}/instance/${vmId}`,
      body,
      options: {
        clsName: this.getClassName(),
        mthdName: 'createLease',
      },
    })
    return response
  }

  updateVmLease = async ({ tenantId, vmId, body }) => {
    const currentTenant = this.client.activeProjectId
    const tenant = tenantId || currentTenant
    const response = await this.client.basicPut<any>({
      url: `/tenant/${tenant}/instance/${vmId}`,
      body,
      options: {
        clsName: this.getClassName(),
        mthdName: 'updateLease',
      },
    })
    return response
  }

  deleteVmLease = async ({ tenantId, vmId }) => {
    const currentTenant = this.client.activeProjectId
    const tenant = tenantId || currentTenant
    return this.client.basicDelete<any>({
      url: `/tenant/${tenant}/instance/${vmId}`,
      options: {
        clsName: this.getClassName(),
        mthdName: 'deleteLease',
      },
    })
  }
}

export default Heat
